import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'password-input',
  template: `
    <div class="w-full">
      <label
        [for]="controlName"
        class="block text-sm font-medium text-gray-700 flex items-center gap-1"
      >
        {{ label }}
        <span *ngIf="isRequired() && label" class="text-red-500">*</span>
      </label>

      <div class="relative">
        <!-- Input field -->
        <input
          [type]="showPassword ? 'text' : 'password'"
          [formControl]="controlName"
          [placeholder]="placeholder"
          [readonly]="readOnly"
          class="h-10 w-full border border-gray-300 px-4 pr-10 rounded-md form-control"
          [class.is-invalid]="controlName.invalid && controlName.touched"
          autocomplete="new-password"
        />

        <!-- Eye toggle button -->
        <button
          *ngIf="!readOnly"
          type="button"
          class="absolute right-2 top-1/2 -translate-y-1/2"
          (click)="togglePassword()"
        >
          <mat-icon
            *ngIf="!showPassword"
            [svgIcon]="'heroicons_solid:eye'"
            class="icon-size-5"
          ></mat-icon>
          <mat-icon
            *ngIf="showPassword"
            [svgIcon]="'heroicons_solid:eye-off'"
            class="icon-size-5"
          ></mat-icon>
        </button>
      </div>

      <!-- Validation errors -->
      <form-validator [controlName]="controlName"></form-validator>
    </div>
  `,
})
export class PasswordInputComponent implements OnInit, OnChanges {
  @Input() label: string = '';
  @Input() controlName: FormControl = new FormControl('', Validators.required);
  @Input() placeholder: string = '';
  @Input() readOnly: boolean = false;
  @Input() disabled: boolean = false;

  showPassword = false;

  ngOnInit(): void {}

  ngOnChanges(): void {
    if (this.disabled) {
      this.controlName.disable();
    } else {
      this.controlName.enable();
    }
    this.controlName.updateValueAndValidity();
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  isRequired(): boolean {
    return this.controlName.hasValidator(Validators.required);
  }
}
